<template>
  <div class="interiorzone">
    <h2 class="subheading">打款认证——认证中</h2>
    <div class="contentbox">
      <div class="content-order-listbox">
        <ul class="content-organ-list">
          <li class="hd">
            <span>序号</span>
            <span>公司名称</span>
            <span>开户行</span>
            <span>账户号</span>
            <span>打款金额</span>
            <span>打款次数</span>
            <span>当前输入次数</span>
            <span>认证是否通过</span>
          </li>
          <li  v-for="(item,index) in companylist" v-bind:key="index">
            <span>{{index + 1}}</span>
            <span>{{item.companyName}}</span>
            <span>{{item.bankAccontName}}</span>
            <span>{{item.bankAccontCode}}</span>
            <span>{{item.bankAmount}}</span>
            <span>{{item.payTimes}}</span>
            <span>{{item.enterPayTimes}}</span>
            <span class="infoperation"><div class="ysbox"><i @click="openpanel(1,item.orderId,item.payTimes,item.enterPayTimes)">通过</i><i @click="openpanel(2,item.orderId,item.payTimes,item.enterPayTimes)">驳回</i></div></span>
          </li>
        </ul>
        <ul class="listpage" v-if="ifpageshow">
          <li @click="loadata(1)">首页</li> <!--这里是1-->
          <li v-for="(item,index) in pagenum" v-bind:key="index" :class="currentPage==item?'active':''"  @click="nextpage(item)">{{item}}</li>
          <li @click="loadata(total)">尾页</li><!--这里是pagenum-->
        </ul>
      </div>
    </div>

    <div class='adopt' v-if="isadopt" >
    <h2>请确认其是否通过打款认证？</h2>
    <div class="btn-confirm"><button class="addok" @click="adopt()">确认</button> <button class="addok" @click="colosepanel(1)">取消</button></div>
    </div>

    <div class='adopt' v-if="isreject">
    <h2>{{errotip}}</h2>
    <div class="btn-confirm"><button class="addok" @click="reject()">确认</button> <button class="addok" @click="colosepanel(1)">取消</button></div>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      pagenum:0,
      currentPage:1,
      pageSize:10,
      companyName:'',
      companylist:[],
      ifpageshow:false,
      errotip:'',
      isadopt:false,
      isreject:false,
      nowid:''
    }
  },
  mounted:function() {
    this.readlist();
  },
  methods: {
    readlist(){
     this.ajax.post('/auth/piaoOrderList',{bizContent:{currentPage:this.currentPage,pageSize:this.pageSize,orderType:'5',orderSubType:'2',status:'260'}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.pagenum=result.data.data.pages
            this.pagenum>1?this.ifpageshow=true:this.ifpageshow=false
            this.companylist=result.data.data.data
          }
        }
      )
    },
    colosepanel(){
      this.isadopt=false
      this.isreject=false
    },
    openpanel(key,id,nm,val){
      this.nowid=id
      if(key==1){
        this.isadopt=true
      }
      else if(key==2){
        //openpanel(2,item.orderId,item.payTimes,item.enterPayTimes)
        if(val==0&&(nm==1||nm==2)){
          this.errotip="请确认是否让其二次输入打款金额？"
        }
        if(nm==1&&(val==1)){
          this.errotip="请确认是否已为其二次打款？"
        }
        if(nm==2&&(val==1)){
          this.errotip="请确认是否驳回其打款认证？"
        }
        this.isreject=true
      }
    },
    adopt(val){
      this.ajax.post('/auth/piaoOrderInspect',{bizContent:{orderId:this.nowid}} )
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.companylist=new Array()
            this.readlist()
            this.adoptpanel=false
          }
          this.colosepanel()
        }
      )
    },
    reject(val){
     this.ajax.post('/auth/piaoOrderReject',{bizContent:{orderId:this.nowid,desc:''}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.companylist=new Array()
            this.rejectboxpanel=false
            this.readlist()
          }
          this.colosepanel()
        }
      ) 
    },
    nextpage(item){
      this.currentPage=item
      this. readlist()
    },
    lookdetails(val){
      console.log(this.companylist[val]);
       this.$router.push({name:'OrganDetails', params: { companyinfo:this.companylist[val]}})
    }
  }
}
</script>

<style>
.adopt{
  position:absolute;
  left:50%;
  margin-left:-137px;
  top:50%;
  margin-top:-59px;
  width:274px;
  height:118px;
  background:rgba(255,255,255,1);
  border:1px solid rgba(14,133,238,1);
  box-shadow:0px 28px 76px rgba(0,0,0,0.17);
  border-radius:5px;
}
.adopt h2{
  width:84%;
  margin:0 8%;
  margin-top:15px;
  text-align: center;
  font-size:16px;
  height:45px;
}
.adopt .btnbox{
  display:table;
  margin:0 auto;
}
.content-organ-list li span:nth-child(3){
  width:16%;
}
</style>


// WEBPACK FOOTER //
// src/page/bankacceptance/payauthentication.vue